import styled from "styled-components";

export const StyledButton = styled.button`
  background-color: ${({ filled }: any) => filled ? '#01509C' : '#fff'};
  border: ${({ filled }: any) => filled ? '' : '1px solid #01509C'};
  border-radius: 7px;
  font-weight: bold;
  color: ${({ filled }: any) => filled ? '#fff' : '#01509C'};
  padding: ${({ filled }: any) => filled ? '3px 10px' : '2px 9px'};
`;